// Component Registry to break circular dependencies
// This is just a central registry for components that would otherwise create circular dependencies

// The registry object that will hold all registered components
const componentRegistry = {
    PatchDetailTable: null
};

/**
 * Register a component in the registry
 * @param {string} componentName - The name of the component to register
 * @param {React.Component} component - The component to register
 */
export function registerComponent(componentName, component) {
    if (componentRegistry[componentName] === undefined) {
        throw new Error(`Component "${componentName}" is not defined in the registry`);
    }
    componentRegistry[componentName] = component;
}

/**
 * Get a component from the registry
 * @param {string} componentName - The name of the component to get
 * @returns {React.Component} The requested component
 */
export function getComponent(componentName) {
    if (componentRegistry[componentName] === undefined) {
        throw new Error(`Component "${componentName}" is not defined in the registry`);
    }
    return componentRegistry[componentName];
}

export default componentRegistry;
